import React from 'react'
import styled from 'styled-components'
import { colors, media } from 'styles'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { finishIntro } from 'store/actions'
import Icon from 'components/Icon'
import { T } from 'components/Translations'

export const StyledIntroPopup = styled(Link)`
  cursor: pointer;
  font-size: 1.2rem;
  line-height: 2;
  background: ${colors.highlight};
  color: ${colors.mainInverted};
  text-decoration: none;
  border-radius: 1rem;
  position: absolute;
  top: 100%;
  left: 80%;
  margin-top: -3rem;
  width: 100%;
  max-width: 30rem;
  box-sizing: border-box;
  z-index: 4; // FindDate has 3
  padding: 1em 2em;
  text-align: center;

  svg {
    font-size: 1.25em;
    padding: 0.5em;
    width: 1em;
    height: 1em;
    float: right;
    margin: -0.8em -1.6em 0 0;
  }
  ::before {
    content: '';
    display: block;
    border: 1rem solid transparent;
    border-top-color: ${colors.highlight};
    position: absolute;
    top: 0;
    left: -1rem;
  }

  ${media.mobile`
    display: none;
  `}
`

const IntroPopup = ({ finishIntro }) => (
  <StyledIntroPopup to="/flirt">
    <Icon
      svg
      src="icon_x_rounded.svg"
      onClick={e => {
        e.preventDefault()
        finishIntro()
      }}
    />
    <T label="messages/tryFlirtOption" />
  </StyledIntroPopup>
)

export default connect(null, { finishIntro })(IntroPopup)
